import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'

export const ModuleSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Header = styled.header`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  margin-bottom: ${Spacing.S8};
`

export const SideActions = styled.aside`
  margin-left: auto;
  padding-left: ${Spacing.S8};
`
